const config = {
  HOST_URL_Live_SSO: "https://fig.sso.id",
  SSO_ClientId: "yXdltQCCCzpPnYGofWncE",
  // SSO_ClientId: "jOVcjTphvHVnaOHbRGtWR",
  // API_HOST_URL_live: "https://localhost:7076",
  // API_HOST_URL_live: "http://figappapi.vidhaninfotech.com",
  // HOST_URL_live_clever: "http://thefigapp.vidhaninfotech.com",
  // API_CHAT_URL_live: "http://figappapi.vidhaninfotech.com/chathub",
  // isProduction: false,

  // API_HOST_URL_live: "https://test.figk-12.com",
  // HOST_URL_live_clever: "https://staging.figk-12.com",
  // API_CHAT_URL_live: "https://test.figk-12.com/chathub",
  // isProduction: false,

  // Custom .NET API host. Defaults to prod (api.figk-12.com, TheFigApp) so an
  // ordinary build is unchanged; figdev is built with
  // REACT_APP_API_HOST=https://apidev.figk-12.com, which is the same .NET API
  // bound to TheFigAppDev. Pair it with REACT_APP_DATA_SLUG=dev so the .NET API
  // and the scaffolded data API point at the same database — setting only one of
  // the two gives you a build that reads prod and dev at the same time.
  API_HOST_URL_live: process.env.REACT_APP_API_HOST || "https://api.figk-12.com",
  API_CHAT_URL_live: `${process.env.REACT_APP_API_HOST || "https://api.figk-12.com"}/chathub`,
  HOST_URL_live_clever: "https://figk-12.com",
  isProduction: true,

  // Scaffolded Azure SQL data API. The slug picks the database: "the" -> TheFigApp (prod),
  // "dev" -> TheFigAppDev. Defaults to "the" so nothing changes unless a build sets the env
  // var, and figdev is built with REACT_APP_DATA_SLUG=dev.
  //
  // ALL scaffold calls go through Config.DATA_API. The call sites that used to hardcode
  // /api/the — and so read production data even on figdev — were migrated 2026-08-03.
  //
  // One deliberate exception remains: CourseCheckIns pins /api/the, because TheFigAppDev has
  // no CourseCheckIn table and the server's checkin route hardcodes DB="TheFigApp". Both
  // sides have to move together; the reason is recorded at that call site.
  DATA_API_SLUG: process.env.REACT_APP_DATA_SLUG || "the",
  DATA_API: `https://azuresql.swancreate.com/api/${process.env.REACT_APP_DATA_SLUG || "the"}`,

  // Partner Portal's hand-written azuresql routes (attribution/consent/pixel events, etc).
  // Slug-aware like DATA_API, and separately overridable so a local demo can point this one
  // route group at a local azuresql while everything else still talks to the real service.
  PARTNERPORTAL_API: process.env.REACT_APP_PARTNERPORTAL_API || `https://azuresql.swancreate.com/api/partnerportal/${process.env.REACT_APP_DATA_SLUG || "the"}`,

  // FIG's own Meta Pixel ID for the partner landing pages (sales.figk-12.com's FFRScholarship /
  // NutritionWebinar / TalkingTurkey campaigns use the same one). Missing -> no pixel, no error.
  META_PIXEL_ID: process.env.REACT_APP_META_PIXEL_ID || "",

  SAML_SSO_BASE: "https://saml.swancreate.com",
  SAML_TENANT_API: "https://figazuresql.swancreate.com/api/erp/saml_tenant",
  SAML_CALLBACK_PATH: "/auth/saml-callback",

  BITMOVIN_PLAYER_KEY: "946c4770-e0e4-40e2-9e61-e245a540cba7",

  // FIG CRM (sales.figk-12.com) integration for inbound web leads
  CRM_DATA_API: "https://figazuresql.swancreate.com/api/crm",
  CRM_LEADS_URL: "https://sales.figk-12.com/leads",
  SCHEDULING_GROUP_ID: "709CACB7-2D22-4F7F-AEC6-5EFB4696D46B",
  // Seeded from CRMGroupMembers.Scheduling — swap to dynamic lookup once
  // figazuresql re-scaffolds CRMGroupMembers route.
  SCHEDULING_RECIPIENTS: [
    { email: "dusty@swank12.com", name: "Dusty Swan" },
  ],

};

export default config